import getFunctionData from "../../../../utils/get-function-data";
import {
  G_appliedTriggerTypes,
  G_references,
} from "../../../../utils/globals/globals";
import WINDOW from "../../../../utils/window";
import pointerup from "../../../listeners/events/pointer-up";
import setAppliedClasses from "./set-applied-classes";

/**
 * Process "applied" trigger properties
 * @param {TriggerProps} trigger
 * @param {String} type
 * @param {String} name
 * @param {String} hash
 * @param {MainClassProps} main
 */
const processApplied = (trigger, type, name, hash, main) => {
  if (!G_appliedTriggerTypes.has(type)) {
    return;
  }

  const applied = main.applied;

  const parameters = /** @type {TriggerParametersProps} */ (
    trigger.get("parameters")
  );
  const target = /** @type {DefaultOptionMapProps} */ (
    /** @type {unknown} */ (parameters?.get("target"))
  );

  const hasTarget = target.get("is-default") ? false : true;

  /**
   * Class trigger
   */
  if (trigger.get("class")) {
    const listeners = /** @type {WindowListenersProps} */ (
      WINDOW.get("listeners")
    );

    listeners.set("class", true);

    const target = hasTarget ? "external" : "local";

    setAppliedClasses(applied, name, hash, target);
  }

  /**
   * Active trigger
   */
  if (trigger.get("active")) {
    if (!applied.has("active")) {
      applied.set("active", []);
    }

    applied.get("active").push(hash);

    const listeners = /** @type {WindowListenersProps} */ (
      WINDOW.get("listeners")
    );

    if (!listeners.get("active")) {
      window.addEventListener("pointerup", pointerup);
      listeners.set("active", true);
    }
  }

  /**
   * Reference
   */
  if (trigger.get("reference")) {
    if (!applied.has("reference")) {
      applied.set("reference", new Map());
    }

    applied.get("reference").set(name, hash);

    if (!G_references.has(name)) {
      G_references.set(name, new Set());
    }

    G_references.get(name).add(main);
  }

  /**
   * Shift
   */
  if (trigger.get("shift")) {
    const rest = /** @type {String} */ (trigger.get("rest"));
    const data = getFunctionData(rest.slice(2, -2));
    const direction = /** @type {ShiftDirectionsProps} */ (data.get("name"));
    const value = data.get("parameters");

    const transformations = new Map([
      ["up", `translateY(-${value})`],
      ["down", `translateY(${value})`],
      ["left", `translateX(-${value})`],
      ["right", `translateX(${value})`],
    ]);

    const result = /** @type {String} */ (transformations.get(direction));

    main.shift.push(result);
  }
};

export default processApplied;
